import { defineStore } from "pinia";
import { ref } from "vue";
import useMyFetch from "@stores/useMyFetch.js";
import { deepCopy } from "@utils/toolBox";
import { useSurveyStore } from "@stores/survey/survey.js";
import handleError from "@composables/handleError.js";

export const useSurveyQuestionsStore = defineStore("surveyQuestions", () => {
  // stores
  const surveyStore = useSurveyStore();

  // state
  const currentQuestions = ref([]);
  const initialQuestions = ref([]);

  // actions
  async function setQuestions() {
    try {
      const { survey } = surveyStore;
      let path = `/surveys/${survey.token}/questions`;
      const { data } = await useMyFetch(path).json();
      currentQuestions.value = data.value;
      initialQuestions.value = deepCopy(data.value);
    } catch (err) {
      handleError(err);
    }
  }

  return {
    // getters
    currentQuestions,

    // actions
    setQuestions,

    // methods
  };
});
